const feedbackStyles = {
  commentContainer: {

  },
  ctaButtonContainer: {
    maxWidth: 350,
    margin: "1rem auto"
  }
}
export default feedbackStyles;